import CloseIcon from '../../../common/icons/close';
import FolderIcon from '../../../common/icons/folder';
import { nameOf } from '../../../global/contexts/catalogs/catalogs';
import { BOARD_PARAMS } from '../utils/board';

import '../styles/board-filter-chips.css';

function Chip({ icon, label, onRemove }) {
    return (
        <li>
            <button type="button" className="board-filter-chips__chip" onClick={onRemove} aria-label={`Quitar filtro: ${label}`}>
                {icon}
                <span className="board-filter-chips__text">{label}</span>
                <CloseIcon size={14} />
            </button>
        </li>
    );
}

// Active filters stay visible as removable chips, so icon-only controls never
// hide what the board is currently narrowed to.
export default function BoardFilterChips({ filters, projects, repositories, tiers, onChange }) {
    const chips = [];
    if (filters.projectId) {
        chips.push({ key: 'project', icon: <FolderIcon size={14} />, label: nameOf(projects, filters.projectId, 'Proyecto'), param: BOARD_PARAMS.PROJECT });
    }
    if (filters.repositoryId) {
        chips.push({ key: 'repo', label: nameOf(repositories, filters.repositoryId, 'Repositorio'), param: BOARD_PARAMS.REPOSITORY });
    }
    if (filters.tierId) {
        chips.push({ key: 'tier', label: nameOf(tiers, filters.tierId, 'Tier').split(' · ')[0], param: BOARD_PARAMS.TIER });
    }
    if (filters.showFindings) {
        chips.push({ key: 'findings', label: 'Con hallazgos', param: BOARD_PARAMS.FINDINGS });
    }
    if (chips.length === 0) return null;

    return (
        <ul className="board-filter-chips" aria-label="Filtros activos">
            {chips.map((chip) => (
                <Chip key={chip.key} icon={chip.icon} label={chip.label} onRemove={() => onChange(chip.param, '')} />
            ))}
        </ul>
    );
}
